import { render, staticRenderFns } from "./ymqc_add.vue?vue&type=template&id=73ca6a1a&scoped=true&"
import script from "./ymqc_add.vue?vue&type=script&lang=js&"
export * from "./ymqc_add.vue?vue&type=script&lang=js&"
import style0 from "./ymqc_add.vue?vue&type=style&index=0&id=73ca6a1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ca6a1a",
  null
  
)

export default component.exports